
/**
 * eum servicio para manejar documentos personales del usuario.
 */
export enum TipoDocumentoPersonalEnum {
    CEDULA_IDENTIDAD = 9,//"CÉDULA DE IDENTIDAD",
    PASAPORTE = 10,//"PASAPORTE",
    LICENCIA_CONDUCIR = 11,//"LICENCIA DE CONDUCIR",
    ACTA_NACIMIENTO = 12 //"ACTA DE NACIMIENTO"
}
